import React, { useEffect, useRef } from 'react';
import Lenis from 'lenis';
import Header from '../components/omvedha/Header';
import StickyCTA from '../components/omvedha/StickyCTA';
import CountdownBanner from '../components/omvedha/CountdownBanner';
import Hero from '../components/omvedha/Hero';
import SevaSchedule from '../components/omvedha/SevaSchedule';
import Benefits from '../components/omvedha/Benefits';
import PoojaDetails from '../components/omvedha/PoojaDetails';
import VenueMap from '../components/omvedha/VenueMap';
import ReserveSeva from '../components/omvedha/ReserveSeva';
import TrustFooter from '../components/omvedha/TrustFooter';
import FloatingWhatsApp from '../components/omvedha/FloatingWhatsApp';
import SevaPicker from '../components/omvedha/SevaPicker';
import { track } from '../lib/analytics';

const Landing = () => {
  const tracked = useRef(false);
  useEffect(() => {
    if (!tracked.current) {
      tracked.current = true;
      track('page_view', 'landing');
    }

    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-ivory" data-testid="landing-page">
      <Header />
      <StickyCTA />
      <CountdownBanner />
      <main>
        <Hero />
        <SevaSchedule />
        <Benefits />
        <PoojaDetails />
        <VenueMap />
        <ReserveSeva />
      </main>
      <TrustFooter />
      <FloatingWhatsApp />
      <SevaPicker />
    </div>
  );
};

export default Landing;
